import { Link } from 'react-router-dom';

const stages = [
  {
    title: 'Этап 1. Определение будущих потребностей',
    desc: 'Какие должности могут потребоваться компании? Какие руководители или специалисты могут понадобиться через 6–12–24 месяца?',
  },
  {
    title: 'Этап 2. Определение профиля должности',
    desc: 'Какие компетенции необходимы для успешного выполнения будущей роли?',
  },
  {
    title: 'Этап 3. Выдвижение кандидатов',
    desc: 'Кандидатов могут рекомендовать руководители или HR, а сотрудник также может заявить о своём интересе к развитию.',
  },
  {
    title: 'Этап 4. Оценка',
    desc: 'Определяем текущий уровень компетенций, потенциал и зоны развития.',
  },
  {
    title: 'Этап 5. Формирование ИПР',
    desc: 'Для каждого резервиста формируется индивидуальный план развития.',
    link: { label: 'Индивидуальный план развития сотрудников', to: '/razvitie-personala/individualnyy-plan-razvitiya-sotrudnikov' },
  },
  {
    title: 'Этап 6. Развитие',
    desc: 'Используются подходящие инструменты: обучение, практика, наставничество, развивающие проекты, бизнес-игры, коучинг, участие в рабочих группах, временное выполнение дополнительных функций.',
  },
  {
    title: 'Этап 7. Наблюдение и обратная связь',
    desc: 'Руководитель и наставник отслеживают прогресс.',
  },
  {
    title: 'Этап 8. Повторная оценка',
    desc: 'Проверяем, насколько сотрудник приблизился к требованиям будущей роли.',
  },
  {
    title: 'Этап 9. Подготовка к назначению',
    desc: 'Если сотрудник готов, он может переходить на новую должность или получать дополнительные зоны ответственности.',
  },
];

export default function HowFormed() {
  return (
    <section id="stages" className="py-16 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как формируется кадровый резерв
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Последовательность шагов — от потребностей компании до подготовки к назначению
        </p>

        <div className="space-y-4">
          {stages.map((s, i) => (
            <div key={i} className="flex items-start gap-4 bg-gray-50 rounded-xl border border-gray-200 p-5 hover:border-teal-200 transition-colors">
              <div className="w-10 h-10 bg-teal-600 text-white rounded-full flex items-center justify-center font-bold flex-shrink-0">
                {i + 1}
              </div>
              <div>
                <h3 className="text-base md:text-lg font-bold text-gray-900 mb-1">{s.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{s.desc}</p>
                {s.link && (
                  <Link to={s.link.to} className="inline-flex items-center gap-1.5 text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap mt-2">
                    {s.link.label}
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}